import { Node, wrappingInputRule } from '@tiptap/core';

export enum AnswerSpaceType {
  Empty = 'empty',
  Line = 'line',
}

export interface AnswerSpaceOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    answerSpace: {
      /**
       * Set a answerSpace node
       */
      setAnswerSpace: () => ReturnType;
      /**
       * Toggle a answerSpace node
       */
      toggleAnswerSpace: () => ReturnType;
      /**
       * Unset a answerSpace node
       */
      unsetAnswerSpace: () => ReturnType;
    };
  }
}

export const inputRegex = /^\s*>\s$/;

const answerSpaceType = 'answerSpace';

const AnswerSpace = Node.create<AnswerSpaceOptions>({
  name: answerSpaceType,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  content: 'block+',

  group: 'block',

  defining: true,

  addAttributes() {
    return {
      lines: {
        default: 2,
      },
      type: {
        default: AnswerSpaceType.Line,
      },
    };
  },

  parseHTML() {
    return [{ tag: 'answer-Space' }];
  },

  renderHTML({ node }) {
    let lines = 2;

    if (node && node.attrs && node.attrs.lines && node.attrs.lines > 2) {
      lines = node.attrs.lines + 1;
    }

    const dom = document.createElement('div');

    Array.from(Array(lines).keys()).forEach(() => {
      const space = document.createElement('div');
      space.style.cssText =
        'border-bottom: 1px solid black;width:100%;height:30px;';
      dom.appendChild(space);
    });

    return dom;
  },

  addCommands() {
    return {
      setAnswerSpace: () => ({ commands }) => {
        return commands.wrapIn(this.name);
      },
      toggleAnswerSpace: () => ({ commands }) => {
        return commands.toggleWrap(this.name);
      },
      unsetAnswerSpace: () => ({ commands }) => {
        return commands.lift(this.name);
      },
    };
  },

  addInputRules() {
    return [
      wrappingInputRule({
        find: inputRegex,
        type: this.type,
      }),
    ];
  },
});

export default { node: AnswerSpace, type: answerSpaceType };
